import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from "axios";
import MainPagetitle from '../../layouts/MainPagetitle';
import { Modal, Button } from 'react-bootstrap';
import PackageService from '../../api/services/PackageService';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
const EditPackages = () => {
  var imageUrl = process.env.REACT_APP_LARAVEL_IMAGE_URL;
  const params = useParams();
  const [error, setError] = useState("")
  const [packages, setPackage] = useState([]);
  const [packageModal, setPackageModal] = useState(false);
  const [isLoading, setisloading] = useState(true);
  const [file, setFile] = useState()
  useEffect(() => {
    var id = params.id;
    getPackageByID(id);
  }, []);

  const getPackageByID = async (id) => {
    try {
      let packages = await PackageService.show(id).json();
      setPackage(packages.data);
      setisloading(false);
    } catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }
  };
  const onFileChange = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var icon = fileReader.result
      setFile(icon)
    }
  }
  const onSubmit = async (event) => {
    event.preventDefault();
    setError("")
    try {
      var userData = {
        "title": event.target.title.value,
        "de_title": event.target.de_title.value,
        "price": event.target.price.value,
        "deposit_price": event.target.deposit_price.value,
        "icon": file ? file.split(',')[1] : "",
      }
      let responseData = await PackageService.update(params.id, userData).json()
      if (responseData.status === true) {
        setPackageModal(true)
      }
    } catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }
  };
  return (
    <>
      <MainPagetitle mainTitle="Carefree Packages" pageTitle={'Carefree Packages'} parentTitle={'Home'} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Edit Carefree Package</h4>
              </div>
              <div className="card-body">
                <form className="form-valide" onSubmit={onSubmit}>
                  <div className="row">
                    {error && <h5 style={{ color: 'red' }}>{error}</h5>}
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >English Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='title' id="val-username"
                        defaultValue={
                          packages.title
                            ? packages.title
                            : ''
                        } />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >German Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_title' id="val-username" placeholder="" defaultValue={
                        packages.de_title
                          ? packages.de_title
                          : ''
                      } />
                    </div>
                    
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label">Price <span className="text-danger">*</span></label>
                      <input type="number" className="form-control" name='price' min={0} defaultValue={packages ? packages.price : ''} />

                    </div>

                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label">Deductible/Deposit Price <span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='deposit_price'
                        defaultValue={
                          packages.deposit_price
                            ? packages.deposit_price
                            : ''
                        } />
                    </div>
                    
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label">Icon <span className="text-danger">*</span></label>
                      {packages.icon ? <img className="img-drop-area" height={100} width={100} name="icon" src={file ? file : imageUrl + "Package/" + packages.icon} alt='' /> : <img className="img-drop-area" height={100} width={100} name="icon" src={file} alt='' />}

                      <input type="file" className="form-control" name='icon' onChange={onFileChange} accept="image/png, image/jpeg, image/svg+xml" />
                    </div>
                  </div>
                  <div>
                    <button type="submit" className="btn btn-primary mb-2 me-1" >Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <LogoAnimationLoader />}
      <Modal centered className="mark-attendence" show={packageModal}>
        <Modal.Header>
          <Modal.Title>Update </Modal.Title>
          <Button variant="" className="btn-close" onClick={() => setPackageModal(false)}></Button>
        </Modal.Header>
        <Modal.Body>Update Package Successfully!!!.</Modal.Body>
        <Modal.Footer>
          <Link className="btn btn-primary" to={'/admin/packages'} variant="danger light" onClick={() => setPackageModal(false)}>Close</Link>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default EditPackages;